export default "__VITE_ASSET__66196bce__"